import React, { useEffect, useMemo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import {Select, Box, Chip, OutlinedInput, FormHelperText, Typography} from '@mui/material';
import { MenuItem } from '@mui/material';
import { InputWrapper } from '../Form/InputWrapper';
import { useState } from 'react';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { useNutsCodes } from '../../api/getNutsCodes';

export function NutsCodes({
  name,
  native = false,
  helperText = '',
  // children,
  PaperPropsSx = {},
  disabled = false,
  fullWidth = false,
  required = false,
  labelSx = {},
  wrapperSx = {},
  label = '',
  defaultValue={},
  options = [],
  value= [],
  // onChange,
  // placeholder,
  methods,
  selectedItems = [],
  ...other
}) {
  const { control } = useFormContext();
  const selectionPropagation = {
    parents: false,
    descendants: true,
  };

  const [selectedNodes, setSelectedNodes] = useState(selectedItems);
  const [expandedNodes, setExpandedNodes] = useState([]);

  const { data } = useNutsCodes();
  
  const treeData = useMemo(() => {
    if (!data?.nutsCodes) return [];
    const mapData = (nodes) => nodes.map(node => ({
      id: node.code,
      label: `${node.code} - ${node.name}`,
      children: node.children ? mapData(node.children) : [],
    }));
    return mapData(data.nutsCodes);
  }, [data]);

  const handleSelectedNodesChange = (event, newSelectedIds) => {
    setSelectedNodes(newSelectedIds);
    methods.setValue("locations", newSelectedIds);

    if (newSelectedIds.length > selectedNodes.length) {
      const newlySelectedNode = newSelectedIds.find(id => !selectedNodes.includes(id));
      if (newlySelectedNode && !expandedNodes.includes(newlySelectedNode)) {
        setExpandedNodes([...expandedNodes, newlySelectedNode]);
      }
    }
  };

  const childToParentMap = useMemo(() => {
    const map = new Map();
    const traverse = (nodes, parentId) => {
      nodes.forEach(node => {
        if (parentId) {
          map.set(node.id, parentId);
        }
        if (node.children) {
          traverse(node.children, node.id);
        }
      });
    };
    traverse(treeData, null);
    return map;
  }, [treeData]);

  useEffect(() => {
    setSelectedNodes(selectedItems);    

      const nodesToExpand = new Set();
      selectedItems.forEach(nodeId => {
        const ancestors = getAncestors(nodeId, childToParentMap);        
        ancestors.forEach(ancestorId => nodesToExpand.add(ancestorId));
      });
      setExpandedNodes(Array.from(nodesToExpand));
  }, [selectedItems, treeData, childToParentMap]);

  const getAncestors = (nodeId, childToParentMap) => {
    const ancestors = [];
    let parentId = childToParentMap.get(nodeId);

    while (parentId) {
      ancestors.push(parentId);
      parentId = childToParentMap.get(parentId);
    }
    return ancestors;
  };
  

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <InputWrapper
            disabled={disabled}
            error={!!error}
            label={label}
            fullWidth={fullWidth}
            required={required}
            labelSx={labelSx}
            wrapperSx={wrapperSx}
          >
            <Box sx={{ height: 250, overflowY: 'auto', border: '1px solid #ddd', borderRadius: 1, p: 1 }}>
              <RichTreeView
                selectionPropagation={selectionPropagation}
                checkboxSelection
                multiSelect
                items={treeData}
                selectedItems={selectedNodes}
                expandedItems={expandedNodes}
                onSelectedItemsChange={handleSelectedNodesChange}
                onExpandedItemsChange={(event, newExpandedIds) => setExpandedNodes(newExpandedIds)}
              />
            </Box>
            {error && (
              <FormHelperText sx={{color: "error.main"}}>{error?.message}</FormHelperText>
            )}
          </InputWrapper>
        );
      }}
    />
  );
}
